/* eslint-disable no-console */
class ContactSearch {
  constructor() {
    // Bind class methods
    this.handleClear = this.handleClear.bind(this);
    this.handleStateSelect = this.handleStateSelect.bind(this);
    this.handleRegionRadio = this.handleRegionRadio.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.init = this.init.bind(this);
    this.renderContactGrid = this.renderContactGrid.bind(this);
    this.renderContactList = this.renderContactList.bind(this);
    this.renderContactCard = this.renderContactCard.bind(this);
    this.toggleView = this.toggleView.bind(this);
    this.handleMapClick = this.handleMapClick.bind(this);
    this.toggleContactMap = this.toggleContactMap.bind(this);

    this.resultsHideClass = 'acg-search-results--hide';

    document.addEventListener('DOMContentLoaded', this.init);
  }

  async init() {
    // Bind DOM elements
    this.form = document.getElementById('contact-search');
    this.gridContainer = document.querySelector(
      '[data-ui="contact-search-results-grid-content"]'
    );
    this.listContainer = document.querySelector(
      '[data-ui="contact-search-results-list-content"]'
    );
    this.emptyMessage = document.querySelector(
      '[data-ui="contact-search-empty"]'
    );
    this.viewChanger = document.querySelector('[data-ui="layout-switcher"]');
    this.listView = document.querySelector(
      '[data-ui="contact-search-results-list-wrapper"]'
    );
    this.gridView = document.querySelector(
      '[data-ui="contact-search-results-grid-wrapper"]'
    );
    this.resultsCount = document.querySelector(
      '[data-ui="contact-search-results-count"]'
    );
    this.resultsLength = 0;
    this.clearBtn = document.querySelector('[data-ui="contact-search-clear"]');
    this.stateSelect = document.querySelector('[data-ui="state-select"]');
    this.stateSelectInput = document.getElementById('select-state');
    this.industrySelect = document.getElementById('select-industry');

    this.regionRadioButtons = document.querySelectorAll(
      '.acg-layout-switcher__opt__input'
    );
    this.pagination = document.querySelector('[data-ui="pagination"]');
    this.paginationButtons = document.querySelectorAll('[data-ui="paginate"]');
    this.currentPageContainer = document.querySelector(
      '[data-ui="current-page"]'
    );
    this.totalPagesContainer = document.querySelector(
      '[data-ui="total-pages"]'
    );
    this.currentPage = 1;
    this.industries = [];
    this.regions = [];
    this.results = [];
    this.sortToggles = document.querySelectorAll('[data-ui="sort"]');
    this.sortBy = 'contact_full_name';
    this.sortOptions = ['', 'asc', 'desc'];
    this.currentSort = 1;
    this.sortingClasses = [
      'acg-table__head__sort--sorted-none',
      'acg-table__head__sort--sorted-asc',
      'acg-table__head__sort--sorted-desc'
    ];
    this.stateSelectedClass = 'acg-map__output__element--selected';

    this.mapContainer = document.querySelector('[data-ui="map"]');
    this.mapOutput = document.querySelector('[data-ui="map-output"]');
    this.mapWrapper = document.querySelector('[data-ui="map-wrapper"]');
    this.mapTriggerOptions = document.querySelectorAll('[data-trigger-map]');
    this.mapViewOption = document.querySelector('[name="map-view"]');
    this.mapTriggerIDs = [];

    this.forceMapView = this.mapViewOption ? this.mapViewOption.checked : false;
    this.hideMap = !this.forceMapView;

    if (this.form) {
      this.form.addEventListener('submit', this.handleSubmit);
      this.form.addEventListener('change', this.handleSubmit);
      this.stateSelectInput.addEventListener('change', this.handleStateSelect);
      this.viewChanger.addEventListener('change', this.toggleView);
      this.clearBtn.addEventListener('click', this.handleClear);
      this.paginationButtons.forEach(page => {
        page.addEventListener('click', this.paginate.bind(this));
      });
      this.sortToggles.forEach(sort => {
        sort.addEventListener('click', this.handleSort.bind(this));
      });

      this.regionRadioButtons.forEach(region => {
        region.addEventListener('click', this.handleRegionRadio.bind(this));
      });

      // set industry IDs that will trigger map
      this.mapTriggerOptions.forEach(trigger => {
        this.mapTriggerIDs.push(trigger.value);
      });

      // initiate Sales Map
      if (this.mapContainer && this.mapOutput) {
        this.states = this.mapContainer.querySelectorAll(
          '.acg-map__input__state'
        );

        this.states.forEach(state => {
          state.addEventListener('click', this.handleMapClick);
        });
      }

      await this.fetchData();
    }

    if (this.forceMapView) {
      const event = document.createEvent('Event');

      this.currentSort = 1;

      this.handleSubmit(event);
    }
  }

  async getAll(request) {
    const response = await request;

    if (!response._paging || !response._paging.next) {
      return response;
    }

    const all = await Promise.all([
      response,
      this.getAll(response._paging.next)
    ]);

    return [].concat(...all);
  }

  async fetchData() {
    const apiSettings = window.WP_API_Settings;

    if (!apiSettings) {
      return;
    }

    this.wp = new WPAPI({
      endpoint: apiSettings.root,
      nonce: apiSettings.nonce
    });

    this.registerRoutes();
    this.regions = await this.getAll(this.wp.regions());
    this.contacts = await this.getAll(this.wp.contacts().perPage(100));
    this.industries = await this.getAll(this.wp.industries().perPage(100));
    this.renderContacts();
  }

  registerRoutes() {
    this.wp.contacts = this.wp.registerRoute('wp/v2', '/contact/(?P<id>)', {
      // Listing any of these parameters will assign the built-in
      // chaining method that handles the parameter:
      params: [
        'before',
        'after',
        'author',
        'parent',
        'post',
        'filter',
        'tags_exclude'
      ]
    });

    this.wp.regions = this.wp.registerRoute('wp/v2', '/region/(?P<id>)', {
      // Listing any of these parameters will assign the built-in
      // chaining method that handles the parameter:
      params: [
        'before',
        'after',
        'author',
        'parent',
        'post',
        'filter',
        'tags_exclude'
      ]
    });

    this.wp.industries = this.wp.registerRoute('wp/v2', '/industry/(?P<id>)', {
      // Listing any of these parameters will assign the built-in
      // chaining method that handles the parameter:
      params: [
        'before',
        'after',
        'author',
        'parent',
        'post',
        'filter',
        'tags_exclude'
      ]
    });
  }

  showRegionNames(regions) {
    const regionList = regions
      .map(regionId => {
        const match = this.regions.find(region => region.id === regionId);

        return match ? match.name : false;
      })
      .filter(Boolean);

    return regionList.join(', ');
  }

  showIndustryNames(industries) {
    const industryList = industries
      .map(industryId => {
        const match = this.industries.find(
          industry => industry.id === industryId
        );

        return match ? match : false;
      })
      .filter(Boolean);

    return industryList;
  }

  filterIndustrySelect(contacts) {
    const contactIndustries = contacts.map(contact => contact.industry);
    const industryIdList = contactIndustries.flat();
    const industryList = new Set(industryIdList);
    const industryIds = [...industryList];
    const industries = this.showIndustryNames(industryIds);
    const select = this.industrySelect;
    const selected = select.options[select.selectedIndex];

    let opt = '<option value="none">Select...</option>';

    if (selected) {
      opt = `<option value="${selected.value}">${selected.text}</option>`;
    }

    industries.sort(function(a, b) {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();

      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });

    industries.forEach(industry => {
      opt += `<option value="${industry.id}">${industry.name}</option>`;
    });

    this.industrySelect.innerHTML = opt;
  }

  buildIndustrySelect(industries) {
    let opt = '<option value="none">Select...</option>';

    industries.forEach(industry => {
      opt += `<option value="${industry.id}">${industry.name}</option>`;
    });

    this.industrySelect.innerHTML = opt;
  }

  renderContactGrid(post) {
    const { acf, title, id, region } = post;

    const regionList = this.showRegionNames(region);

    const fields = {
      name: title.rendered,
      role: acf.contact_job_title,
      region: regionList,
      company: acf.contact_company,
      headshot: acf.contact_headshot,
      id: id
    };

    return `
    <div class="acg-person">
      <div class="acg-person__image">
      ${
        fields.headshot
          ? `<img src="${fields.headshot}" alt="${fields.name}">`
          : '<img src="/wp-content/themes/arch-global/static/photo-unavailable.jpg" alt="Photo coming soon">'
      }
      </div>
      <div class="acg-person__info">
        <h3 class="acg-person__name">${fields.name}</h3>
        <ul class="acg-person__meta">
          ${fields.role &&
            `<li class="acg-person__title">
            ${fields.role}
          </li>`}
          ${fields.region &&
            `<li class="acg-person__region">
            ${fields.region}
          </li>`}
        </ul>
        <button data-ui="modal-trigger" aria-controls="modal-flexible" type="button" data-modal-type="person" data-id="${
          fields.id
        }" class="acg-btn acg-btn--link">Read More</button>
      </div>
    </div>`;
  }

  renderContactCard(post) {
    const { acf, title, id, region } = post;

    const regionList = this.showRegionNames(region);

    const fields = {
      name: title.rendered,
      role: acf.contact_job_title,
      region: regionList,
      email: acf.contact_email_address,
      phone: acf.contact_direct_phone_number || acf.contact_mobile_phone_number,
      id: id
    };

    const phoneLink = fields.phone
      .trim()
      .replace(/\(/g, '')
      .replace(/\)/g, '')
      .replace(/\+ /, '+')
      .replace(/ /g, '-');

    return `<div class="acg-card acg-card--contact">
    ${
      fields.headshot
        ? `<div class="acg-card__image" style="background-image: url(${fields.headshot})"></div>`
        : ``
    }
    <div class="acg-card__content">
      <h3 class="acg-card__heading">${fields.name}</h3>
      <p class="acg-card__desc">${fields.role} ${
      fields.region ? `- ${fields.region}` : ''
    }</p>
      ${
        fields.phone || fields.email
          ? `<div class="acg-card__meta">
        ${
          fields.phone
            ? `<p class="acg-card__meta__item">
            <i class="acg-icon fas fa-phone"></i>
            <a href="tel:${phoneLink}" target="_blank">${fields.phone}</a>
          </p>`
            : ``
        }
        ${
          fields.email
            ? `<p class="acg-card__meta__item">
            <i class="acg-icon fas fa-envelope"></i>
            <a href="mailto:${fields.email}">${fields.email}</a>
          </p>`
            : ``
        }
      </div>`
          : ``
      }
    </div>
  </div>`;
  }

  renderContactList(post) {
    const { acf, title, id, region } = post;

    const regionList = this.showRegionNames(region);

    const fields = {
      name: title.rendered,
      role: acf.contact_job_title,
      region: regionList,
      email: acf.contact_email_address,
      phone: acf.contact_direct_phone_number || acf.contact_mobile_phone_number,
      id: id
    };

    const phoneLink = fields.phone
      .trim()
      .replace(/\(/g, '')
      .replace(/\)/g, '')
      .replace(/\+ /, '+')
      .replace(/ /g, '-');

    return `
    <tr class="acg-table__body__row">
      <td class="acg-table__body__item acg-table__body__item--mobile">
        <button
        data-ui="modal-trigger"
        aria-controls="modal-flexible"
        type="button"
        data-modal-type="person"
        data-id="${fields.id}"
        class="acg-btn acg-btn--link">
          ${fields.name}
        </button>

        <span class="acg-table__mobile__value">${fields.region}</span>
        <span class="acg-table__mobile__value">${fields.role}</span>
        <span class="acg-table__mobile__value"><a href="mailto:${fields.email}">${fields.email}</a></span>
        <span class="acg-table__mobile__value"><a href="tel:${phoneLink}" target="_blank">${fields.phone}</a></span>
      </td>
      <td class="acg-table__body__item">
        <button
          data-ui="modal-trigger"
          aria-controls="modal-flexible"
          type="button"
          data-modal-type="person"
          data-id="${fields.id}"
          class="acg-btn acg-btn--link">
          ${fields.name}
          </button>
      </td>
      <td class="acg-table__body__item">${fields.region}</td>
      <td class="acg-table__body__item">${fields.role}</td>
      <td class="acg-table__body__item"><a href="mailto:${fields.email}">${fields.email}</a></td>
      <td class="acg-table__body__item"><a href="tel:${phoneLink}" target="_blank">${fields.phone}</a></td>
    </tr>
    `;
  }

  renderResults() {
    const gridElements = this.results.map(this.renderContactGrid);
    const gridMarkup = gridElements.join('');

    const listElements = this.results.map(this.renderContactList);
    const listMarkup = listElements.join('');

    const cardElements = this.results.map(this.renderContactCard);
    const cardMarkup = cardElements.join('');

    this.gridContainer.innerHTML = gridMarkup;
    this.listContainer.innerHTML = listMarkup;
    this.mapOutput.innerHTML = cardMarkup;

    this.toggleControls();
  }

  getValues(form) {
    return {
      cu: form.elements['credit-union'].value === 'true',
      region: this.getRadioValues('region'),
      name: form.elements.name.value,
      industry: form.elements.industry.value,
      state: form.elements.state.value,
      segment: form.elements.segment.value,
      tags: form.elements.tags.value
    };
  }

  getRadioValues(name) {
    return document.querySelector(`[name="${name}"]:checked`).value;
  }

  toggleControls() {
    const perPage = this.hideMap ? 8 : 100;

    if (this.resultsLength > perPage) {
      this.pagination.style.cssText = '';

      this.currentPageContainer.innerHTML = this.currentPage;
      this.totalPagesContainer.innerHTML =
        this.results && this.results._paging
          ? this.results._paging.totalPages
          : 0;

      // eslint-disable-next-line eqeqeq
      if (this.results._paging.totalPages == this.currentPage) {
        this.disablePagination(document.querySelector('[data-page="next"]'));
      }

      // eslint-disable-next-line eqeqeq
      if (this.currentPage == this.results._paging.totalPages - 1) {
        this.enablePagination(document.querySelector('[data-page="next"]'));
      }

      // eslint-disable-next-line eqeqeq
      if (this.currentPage == 1) {
        this.disablePagination(document.querySelector('[data-page="prev"]'));
      }

      // eslint-disable-next-line eqeqeq
      if (this.currentPage == 2) {
        this.enablePagination(document.querySelector('[data-page="prev"]'));
      }
    } else {
      this.pagination.style.cssText = 'display: none;';
    }

    this.emptyMessage.style.cssText =
      this.resultsLength > 0 ? '' : 'display: block;';
  }

  handleClear() {
    this.form.reset();
    this.clearBtn.style.cssText = '';

    this.clearStates();

    if (!this.forceMapView) {
      // Hide map
      this.toggleContactMap('', 0);
    }

    this.renderContacts();
    this.form.elements[0].focus();

    if (this.industrySelect) {
      this.buildIndustrySelect(this.industries);
    }
  }

  async handleSubmit(event, showClearBtn) {
    event.preventDefault();

    const values = this.getValues(this.form);
    const sortOrder = this.sortOptions[this.currentSort];
    const query = { orderby: 'meta_value', meta_key: this.sortBy };
    const query_total = {
      orderby: 'meta_value',
      meta_key: this.sortBy,
      numberposts: -1
    };

    if (!this.isMapRegion(values.region)) {
      values.state = 'none';
    }
    // If state is set to none, defer to parent region.
    // This prevents an empty 'State' selection from showing ALL people
    values.state = values.state === 'none' ? values.region : values.state;

    // If industry is none, pass in null to prevent invalid parameter
    values.industry = values.industry === 'none' ? null : values.industry;

    await this.toggleContactMap(values.region, values.industry);

    const perPage = this.hideMap ? 8 : 100;

    // Return Contacts WHERE region matches AND state matches AND industry matches
    // order alphabetically A to Z
    this.results = await this.wp
      .contacts()
      .search(values.name)
      .excludeTags(values.tags)
      .param('region', values.region)
      .param('region', values.state)
      .param('industry', values.industry)
      .filter({
        meta_query: [
          {
            key: 'contact_business_segment',
            value: values.segment
          }
        ]
      })
      .filter(query)
      .order(sortOrder)
      .perPage(perPage)
      .page(1);

    this.resultsFull = await this.wp
      .contacts()
      .search(values.name)
      .excludeTags(values.tags)
      .param('region', values.region)
      .param('region', values.state)
      .param('industry', values.industry)
      .filter({
        meta_query: [
          {
            key: 'contact_business_segment',
            value: values.segment
          }
        ]
      })
      .filter(query_total)
      .order(sortOrder)
      .perPage(100);

    this.resultsFullPg2 = await this.wp
      .contacts()
      .search(values.name)
      .excludeTags(values.tags)
      .param('region', values.region)
      .param('region', values.state)
      .param('industry', values.industry)
      .filter({
        meta_query: [
          {
            key: 'contact_business_segment',
            value: values.segment
          }
        ]
      })
      .filter(query)
      .offset(100)
      .order(sortOrder)
      .perPage(100);

    this.totalResults = this.resultsFullPg2
      ? [...this.resultsFull, ...this.resultsFullPg2]
      : this.resultsFull;

    this.resultsLength =
      this.results && this.results._paging ? this.results._paging.total : 0;
    this.currentPage = 1;

    this.renderResultsCount();
    this.renderResults();
    this.toggleStateSelect(values.region);

    if (
      this.industrySelect &&
      (values.industry !== null || values.industry !== '')
    ) {
      this.filterIndustrySelect(this.totalResults);
    } else if (this.industrySelect) {
      this.buildIndustrySelect(this.industries);
    }

    if (!this.forceMapView || event.type === 'change' || showClearBtn) {
      this.clearBtn.style.cssText = 'display: inline-block;';
    }
  }

  handleStateSelect(event) {
    if (!this.mapViewOption.checked) {
      return;
    }

    const select = event.target;
    const selected = select.options[select.selectedIndex];
    const selectedId = selected.textContent.toLowerCase().replace(/\s/g, '-');
    const selectedPath = document.getElementById(selectedId);

    this.states.forEach(state => {
      state.classList.remove(this.stateSelectedClass);
    });

    if (selectedPath) {
      selectedPath.classList.add(this.stateSelectedClass);
    }
  }

  handleRegionRadio() {
    this.buildIndustrySelect(this.industries);
  }

  isMapRegion(regionId) {
    let regionName = '';

    if (regionId !== '') {
      const match = this.regions.find(region => region.id === Number(regionId));

      if (match) {
        regionName = match.slug;
      }
    }

    return regionName === 'united-states' || regionName === 'us-credit-unions';
  }

  async toggleStateSelect(regionId) {
    this.stateSelect.style.cssText = this.isMapRegion(regionId)
      ? 'display: block;'
      : '';
  }

  renderResultsCount() {
    const pluralize = !this.resultsLength || this.resultsLength > 1 ? 's' : '';
    const resultsText = 'Found ' + this.resultsLength + ' result' + pluralize;

    this.resultsCount.innerHTML = resultsText;

    this.listView.style.cssText =
      this.resultsLength === 0 || !this.hideMap ? 'display: none' : '';
  }

  async renderContacts() {
    const values = this.getValues(this.form);
    const query = { orderby: 'meta_value', meta_key: this.sortBy };

    this.results = await this.wp
      .contacts()
      .excludeTags(values.tags)
      .filter({
        meta_query: [
          {
            key: 'contact_business_segment',
            value: values.segment
          }
        ]
      })
      .filter(query)
      .order('asc')
      .perPage(8)
      .page(1);

    this.resultsLength = this.results._paging.total;
    this.currentPage = 1;
    this.renderResultsCount();
    this.renderResults();
  }

  async paginate(event) {
    const trigger = event.currentTarget;
    const direction = trigger.getAttribute('data-page');

    if (direction === 'next') {
      this.currentPage++;
      this.results = await this.results._paging.next;
    } else {
      this.currentPage--;
      this.results = await this.results._paging.prev;
    }

    this.renderResults();
  }

  disablePagination(trigger) {
    trigger.setAttribute('aria-disabled', true);
    trigger.disabled = true;
    trigger.classList.add('acg-pagination__link--disabled');
  }

  enablePagination(trigger) {
    trigger.setAttribute('aria-disabled', false);
    trigger.disabled = false;
    trigger.classList.remove('acg-pagination__link--disabled');
  }

  toggleView() {
    const view = this.getRadioValues('layout-switcher');

    if (view === 'grid') {
      this.listView.classList.add(this.resultsHideClass);
      this.gridView.classList.remove(this.resultsHideClass);
    } else {
      this.gridView.classList.add(this.resultsHideClass);
      this.listView.classList.remove(this.resultsHideClass);
    }
  }

  handleSort(event) {
    const trigger = event.currentTarget;
    const sortField = trigger.getAttribute('sort-by');

    const lastSort = this.currentSort;

    this.sortBy = sortField;
    this.currentSort = lastSort === 2 ? 0 : lastSort + 1;

    const sortClass = this.sortingClasses[this.currentSort];

    this.setSortingClasses(trigger, sortClass);

    this.handleSubmit(event);
  }

  setSortingClasses(trigger, sortClass) {
    this.sortToggles.forEach(toggle => {
      toggle.classList.remove(...this.sortingClasses);
    });

    trigger.classList.add(sortClass);
  }

  clearStates() {
    this.states.forEach(state => {
      state.classList.remove(this.stateSelectedClass);
    });
  }

  // Sales Map
  async handleMapClick(event) {
    const target = event.currentTarget;
    const h2 = document.createElement('h2');
    const values = this.getValues(this.form);
    const location = target.getAttribute('name');

    let locationSlug = target.getAttribute('id');

    if (values.cu) {
      locationSlug += '-us-credit-unions';
    }

    this.clearStates();
    target.classList.add(this.stateSelectedClass);

    h2.className = 'acg-map__output__heading';
    h2.textContent = `Loading contacts from ${location}...`;

    this.mapOutput.innerHTML = '';
    this.mapOutput.appendChild(h2);

    const selectedRegions = this.regions
      .filter(region => region.slug === locationSlug)
      .map(region => String(region.id));

    if (selectedRegions.length) {
      this.stateSelectInput.value = selectedRegions[0];

      // Submit and show clear button
      this.handleSubmit(event, true);
    } else {
      h2.textContent = `No contacts found from ${location}.`;
      this.clearBtn.style.cssText = 'display: inline-block;';
      this.resultsLength = 0;
      this.renderResultsCount();
    }
  }

  async toggleContactMap(region, industry) {
    // If the industry matches the trigger industry
    // and the region is united states
    // show sales map
    if (
      this.isMapRegion(region) &&
      (this.mapTriggerIDs.indexOf(industry) >= 0 || this.forceMapView)
    ) {
      this.mapWrapper.style.cssText = 'display: block;';
      this.gridView.style.cssText = 'display: none';
      this.listView.style.cssText = 'display: none';
      this.viewChanger.style.cssText = 'display: none';
      this.hideMap = false;
    } else {
      this.mapWrapper.style.cssText = '';
      this.gridView.style.cssText = '';
      this.listView.style.cssText = '';
      this.viewChanger.style.cssText = '';
      this.hideMap = true;

      // Reset all state selection styles
      this.clearStates();
    }
  }
}

export default ContactSearch;
